import React, { ReactNode } from "react";
import {
  compose,
  sizing,
  grid,
  flexbox,
  display,
  palette,
  spacing,
  borders,
  typography,
  SizingProps,
  GridProps,
  FlexboxProps,
  DisplayProps,
  PaletteProps,
  SpacingProps,
  TypographyProps,
  breakpoints,
  BordersProps,
} from "@material-ui/system";
import { styled } from "@material-ui/core/styles";

const StyledBox = styled("div")(
  breakpoints(
    compose(
      sizing,
      grid,
      flexbox,
      display,
      palette,
      spacing,
      typography,
      borders
    )
  )
);

export interface IProps
  extends SizingProps,
    GridProps,
    FlexboxProps,
    DisplayProps,
    PaletteProps,
    SpacingProps,
    BordersProps,
    TypographyProps {
  className?: string;
  style?: React.CSSProperties;
  children?:ReactNode
  id?: string;
}

const Box: React.FC<IProps> = React.forwardRef(
  ({ children, display = "grid", id, ...rest }, ref) => {
    return (
      <StyledBox display={display} {...rest} ref={ref as any} id={id}>
        {children}
      </StyledBox>
    );
  }
);

export default Box;
